<template>
  <div>
    <div class="card bg-dark">
      <b-table
        class="table-dark"
        :items="units"
        :fields="fields"
        :sortBy="sortBy"
        sortDesc
        @row-clicked="(record) => selectUnit(record.key)"
      >
        <template #cell(createdAt)="data">
          {{ formatDateTime(data.value) }}
        </template>
        <template #cell(dateConfigPull)="data">
          {{ formatDateTime(data.value) }}
        </template>
        <template #cell(dateHello)="data">
          {{ formatDateTime(data.value) }}
        </template>
      </b-table>

      <b-modal
        v-if="$store.getters.isAdmin"
        id="editModal"
        title="Edit Unit"
        @ok="updateUnit(editUnit)"
      >
      </b-modal>
    </div>
  </div>
</template>

<script>
import { formatDateTime } from "../utils";

export default {
  name: "UnitList",
  props: {
    units: {
      type: Array,
    },
   fields: {
      type: Array,
    },
    sortBy: {
      type: String,
    },
  },
  data() {
    return {
      dispUnits: [],
      selectuserId: null,
    };
  },
  computed: {},
  methods: {
    formatDateTime,

    selectUnit(id) {
      this.$emit("selectUnit", id);
    },
  },

  beforeMount() {
    this.dispUnits = this.units;
  },
};
</script>
